import { configureStore } from "@reduxjs/toolkit"

import authReducer from "./slices/auth"
import brandReducer from "./slices/brand"
import productReducer from "./slices/product"
import offerReducer from "./slices/offer"
import testimonialReducer from "./slices/testimonial"
import uploadReducer from "./slices/upload"
import modalReducer from "./slices/modal"

export const store = configureStore({
    reducer: {
        auth: authReducer,
        brand: brandReducer,
        product: productReducer,
        offer: offerReducer,
        testimonial: testimonialReducer,
        upload: uploadReducer,
        modal: modalReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
})